import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import styled, {createGlobalStyle} from "styled-components";
import dynamic from "next/dynamic";
import NewThankYou from "../NewThankYou";

const Register = dynamic(() => import("components/NewPartners/Register"), {ssr: false});
const GetStartedModal = dynamic(() => import("components/commons/Login/GetStartedModal"), {ssr: false});

const propTypes = {
  thankYouStep: PropTypes.number
};

const SignUpModalGlobalStyle = createGlobalStyle`
  #register, #register-thankyou, #share {
    transition: all 0s, opacity 300ms ease-in-out;
    opacity: 0;
    visibility: hidden;
  }

  #register:target, #register-thankyou:target, #share:target {
    transition: all 0s, opacity 300ms ease-in-out;
    opacity: 1;
    visibility: visible;
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 999;

    & > div > div {
      transform: translate(-50%, -50%);
      transition: all 0.25s ease-in-out;
    }
  }
`;

const PartnerAuthModals = ({thankYouStep = 4}) => {
  const [toggleModal, setToggleModal] = useState(false);

  const handleCloseModal = () => {
    setToggleModal(false);
    const currentScroll = window.scrollY;
    window.history.replaceState(null, "", window.location.pathname);
    window.scrollTo(0, currentScroll);
  };

  useEffect(() => {
    const syncBodyScrollLock = () => {
      const hash = window.location.hash;
      const shouldLockScroll = hash === "#register" || hash === "#login" || hash.startsWith("#register-thankyou");

      if (shouldLockScroll) {
        document.body.classList.add("hide-scroll");
      } else {
        document.body.classList.remove("hide-scroll");
      }
    };

    const handleHashChange = () => {
      const hash = window.location.hash;
      const currentScroll = window.scrollY;

      setToggleModal(hash === "#login");
      syncBodyScrollLock();

      requestAnimationFrame(() => {
        window.scrollTo(0, currentScroll);
      });
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
      document.body.classList.remove("hide-scroll");
    };
  }, []);

  return (
    <>
      <SignUpModalGlobalStyle />

      <LoginModal id="login" $visible={toggleModal}>
        <GetStartedModal
          setToggleModal={handleCloseModal}
          toggleModal={toggleModal}
        />
      </LoginModal>

      <div id="register">
        <Register />
      </div>

      <div id="register-thankyou">
        <ThankYouModalContainer>
          <ThankYouModalContentContainer>
            <NewThankYou step={thankYouStep} />
          </ThankYouModalContentContainer>
        </ThankYouModalContainer>
      </div>
    </>
  );
};

PartnerAuthModals.propTypes = propTypes;

const LoginModal = styled.div`
  display: ${({$visible}) => ($visible ? "block" : "none")};
`;

const ThankYouModalContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: #261E38;
  z-index: 999;
`;

const ThankYouModalContentContainer = styled.div`
  position: absolute;
  display: block;
  line-height: 1.8;
  width: 100rem;
  height: 64rem;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.2);
  border-radius: 2.4rem;
  background-color: #f5f5f5;
  color: #34495E;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 85%;
    padding: 4rem 2rem;
  }
`;

export default PartnerAuthModals;
